<div *ngIf="!isEdited" class="cell-view">
  <div class="inner-view">●●●●●●●●</div>
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="PasswordCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && rowData[fieldName] != null"
      id="cancelRowSelection"
      data-cy="PasswordCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
</div>

<ng-container *ngIf="isEdited">
  <ng-container *ngIf="showInputAsOverlay(minWidthPx); else woOverlay">
    <jml-lib-overlay [visible]="true" [widthPx]="2 * minWidthPx" overlayCssClass="p-1">
      <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
    </jml-lib-overlay>
  </ng-container>
</ng-container>

<ng-template #woOverlay>
  <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
</ng-template>

<ng-template #inputTpl>
  <div class="p-inputgroup">
    <input
      #passwordInput
      [name]="fieldName"
      type="password"
      [(ngModel)]="rowData[fieldName]"
      style="width: calc(100% - 30px)"
      pInputText
      autocomplete="new-password"
      (click)="$event.stopPropagation()"
      (keyup.enter)="onKeyupEnter()"
      (keyup.esc)="abortCellEdit($event)"
      (blur)="abortCellEdit($event)"
      jmlAutoFocus
    />
    <button
      pButton
      type="button"
      [id]="fieldName + '§' + rowData['id']"
      icon="pi pi-check"
      [disabled]="mandatory && !rowData[fieldName]"
    ></button>
  </div>
</ng-template>
